function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { utils as utils_exports, CONSTANTS as constants_exports, AbstractAdapter, events as events_exports, PSVError } from '../core/index.module.js';
import { BoxGeometry, ShaderMaterial, Vector2, Mesh, VideoTexture } from '../../three/build/three.module.js';
/*!
 * PhotoSphereViewer.CubemapVideoAdapter 5.0.1
 * @copyright 2022 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */

var AbstractVideoAdapter = /*#__PURE__*/function (_AbstractAdapter) {
  _inherits(AbstractVideoAdapter, _AbstractAdapter);

  var _super = _createSuper(AbstractVideoAdapter);

  function AbstractVideoAdapter(viewer) {
    var _this;

    _classCallCheck(this, AbstractVideoAdapter);

    _this = _super.call(this, viewer);

    _this.viewer.addEventListener(events_exports.BeforeRenderEvent.type, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(AbstractVideoAdapter, [{
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports.BeforeRenderEvent.type, this);

      this.__removeVideo();

      _get(_getPrototypeOf(AbstractVideoAdapter.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports.BeforeRenderEvent) {
        this.viewer.needsUpdate();
      }
    }
  }, {
    key: "supportsPreload",
    value: function supportsPreload() {
      return false;
    }
  }, {
    key: "supportsTransition",
    value: function supportsTransition() {
      return false;
    }
  }, {
    key: "loadTexture",
    value: function loadTexture(panorama) {
      if (_typeof(panorama) !== "object" || !panorama.source) {
        return Promise.reject(new PSVError("Invalid panorama configuration, are you using the right adapter?"));
      }

      if (!this.viewer.getPlugin("video")) {
        return Promise.reject(new PSVError("Video adapters require VideoPlugin to be loaded too."));
      }

      var video = this.__createVideo(panorama.source);

      return this.__videoLoadPromise(video).then(function () {
        var texture = new VideoTexture(video);
        return {
          panorama: panorama,
          texture: texture
        };
      });
    }
  }, {
    key: "switchVideo",
    value: function switchVideo(texture) {
      var currentTime;
      var duration;
      var paused = !this.config.autoplay;
      var muted = this.config.muted;
      var volume = 1;

      if (this.video) {
        var _this$video = this.video;
        currentTime = _this$video.currentTime;
        duration = _this$video.duration;
        paused = _this$video.paused;
        muted = _this$video.muted;
        volume = _this$video.volume;
      }

      this.__removeVideo();

      this.video = texture.image;

      if (this.video.duration === duration) {
        this.video.currentTime = currentTime;
      }

      this.video.muted = muted;
      this.video.volume = volume;

      if (!paused) {
        this.video.play();
      }
    }
  }, {
    key: "setTextureOpacity",
    value: function setTextureOpacity(mesh, opacity) {
      mesh.material.opacity = opacity;
      mesh.material.transparent = opacity < 1;
    }
  }, {
    key: "setOverlay",
    value: function setOverlay() {
      throw new PSVError("VideoAdapter does not support overlay");
    }
  }, {
    key: "disposeTexture",
    value: function disposeTexture(textureData) {
      var _textureData$texture;

      if (textureData.texture) {
        var video = textureData.texture.image;
        video.pause();
        this.viewer.container.removeChild(video);
      }

      (_textureData$texture = textureData.texture) === null || _textureData$texture === void 0 ? void 0 : _textureData$texture.dispose();
    }
  }, {
    key: "__removeVideo",
    value: function __removeVideo() {
      if (this.video) {
        this.video.pause();
        this.viewer.container.removeChild(this.video);
        delete this.video;
      }
    }
  }, {
    key: "__createVideo",
    value: function __createVideo(src) {
      var video = document.createElement("video");
      video.crossOrigin = this.viewer.config.withCredentials ? "use-credentials" : "anonymous";
      video.loop = true;
      video.playsInline = true;
      video.style.display = "none";
      video.muted = this.config.muted;
      video.src = src;
      video.preload = "metadata";
      this.viewer.container.appendChild(video);
      return video;
    }
  }, {
    key: "__videoLoadPromise",
    value: function __videoLoadPromise(video) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var onLoaded = function onLoaded() {
          if (_this2.video && video.duration === _this2.video.duration) {
            resolve(_this2.__videoBufferPromise(video, _this2.video.currentTime));
          } else {
            resolve();
          }

          video.removeEventListener("loadedmetadata", onLoaded);
        };

        var onError = function onError(err) {
          reject(err);
          video.removeEventListener("error", onError);
        };

        video.addEventListener("loadedmetadata", onLoaded);
        video.addEventListener("error", onError);
      });
    }
  }, {
    key: "__videoBufferPromise",
    value: function __videoBufferPromise(video, currentTime) {
      return new Promise(function (resolve) {
        function onBuffer() {
          var buffer = video.buffered;

          for (var i = 0, l = buffer.length; i < l; i++) {
            if (buffer.start(i) <= video.currentTime && buffer.end(i) >= video.currentTime) {
              video.pause();
              video.removeEventListener("buffer", onBuffer);
              video.removeEventListener("progress", onBuffer);
              resolve();
              break;
            }
          }
        }

        video.currentTime = Math.min(currentTime + 2e3, video.duration);
        video.muted = true;
        video.addEventListener("buffer", onBuffer);
        video.addEventListener("progress", onBuffer);
        video.play();
      });
    }
  }]);

  return AbstractVideoAdapter;
}(AbstractAdapter);

AbstractVideoAdapter.supportsDownload = false;
AbstractVideoAdapter.supportsOverlay = false; // src/CubemapVideoAdapter.ts

var getConfig = utils_exports.getConfigParser({
  equiangular: true,
  autoplay: false,
  muted: false
});

var CubemapVideoAdapter = /*#__PURE__*/function (_AbstractVideoAdapter) {
  _inherits(CubemapVideoAdapter, _AbstractVideoAdapter);

  var _super2 = _createSuper(CubemapVideoAdapter);

  function CubemapVideoAdapter(viewer, config) {
    var _this3;

    _classCallCheck(this, CubemapVideoAdapter);

    _this3 = _super2.call(this, viewer);
    _this3.config = getConfig(config);
    return _this3;
  }

  _createClass(CubemapVideoAdapter, [{
    key: "createMesh",
    value: function createMesh() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var cubeSize = constants_exports.SPHERE_RADIUS * 2 * scale;
      var geometry = new BoxGeometry(cubeSize, cubeSize, cubeSize).scale(1, 1, -1).toNonIndexed();
      geometry.clearGroups();
      var uvs = geometry.getAttribute("uv");
      var a = 0;
      var b = 1 / 3;
      var c = 2 / 3;
      var d = 1;
      var A = 1;
      var B = 1 / 2;
      var C = 0;
      uvs.setXY(0, a, A);
      uvs.setXY(1, a, B);
      uvs.setXY(2, b, A);
      uvs.setXY(3, a, B);
      uvs.setXY(4, b, B);
      uvs.setXY(5, b, A);
      uvs.setXY(6, c, A);
      uvs.setXY(7, c, B);
      uvs.setXY(8, d, A);
      uvs.setXY(9, c, B);
      uvs.setXY(10, d, B);
      uvs.setXY(11, d, A);
      uvs.setXY(12, d, B);
      uvs.setXY(13, c, B);
      uvs.setXY(14, d, C);
      uvs.setXY(15, c, B);
      uvs.setXY(16, c, C);
      uvs.setXY(17, d, C);
      uvs.setXY(18, b, B);
      uvs.setXY(19, a, B);
      uvs.setXY(20, b, C);
      uvs.setXY(21, a, B);
      uvs.setXY(22, a, C);
      uvs.setXY(23, b, C);
      uvs.setXY(24, c, B);
      uvs.setXY(25, b, B);
      uvs.setXY(26, c, C);
      uvs.setXY(27, b, B);
      uvs.setXY(28, b, C);
      uvs.setXY(29, c, C);
      uvs.setXY(30, b, A);
      uvs.setXY(31, b, B);
      uvs.setXY(32, c, A);
      uvs.setXY(33, b, B);
      uvs.setXY(34, c, B);
      uvs.setXY(35, c, A);
      var material = new ShaderMaterial({
        uniforms: {
          mapped: {
            value: null
          },
          contCorrect: {
            value: 1
          },
          faceWH: {
            value: new Vector2(1 / 3, 1 / 2)
          },
          vidWH: {
            value: new Vector2(1, 1)
          }
        },
        vertexShader: "\nvarying vec2 vUv;\nvoid main() {\n  vUv = uv;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.);\n}",
        fragmentShader: "\nvarying vec2 vUv;\nuniform sampler2D mapped;\nuniform vec2 faceWH;\nuniform vec2 vidWH;\nuniform float contCorrect;\n\nconst float PI = 3.1415926535897932384626433832795;\n\nvoid main() {\n  vec2 corner = vUv - mod(vUv, faceWH) + vec2(0, contCorrect / vidWH.y);\n  vec2 faceWHadj = faceWH - vec2(0, contCorrect * 2. / vidWH.y);\n  vec2 p = (vUv - corner) / faceWHadj - .5;\n  vec2 q = ".concat(this.config.equiangular ? "2. / PI * atan(2. * p) + .5" : "p + .5", ";\n  vec2 eUv = corner + q * faceWHadj;\n  gl_FragColor = texture2D(mapped, eUv);\n}")
      });
      return new Mesh(geometry, material);
    }
  }, {
    key: "setTexture",
    value: function setTexture(mesh, textureData) {
      var _mesh$material$unifor;

      var texture = textureData.texture;
      var video = texture.image;
      (_mesh$material$unifor = mesh.material.uniforms.mapped.value) === null || _mesh$material$unifor === void 0 ? void 0 : _mesh$material$unifor.dispose();
      mesh.material.uniforms.mapped.value = texture;
      mesh.material.uniforms.vidWH.value.set(video.videoWidth, video.videoHeight);
      this.switchVideo(textureData.texture);
    }
  }]);

  return CubemapVideoAdapter;
}(AbstractVideoAdapter);

CubemapVideoAdapter.id = "cubemap-video";
export { CubemapVideoAdapter };
//# sourceMappingURL=index.module.js.map
